'use strict';

module.exports = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};



//////////////////
// WEBPACK FOOTER
// ./~/annonces-app-modules/~/axios/lib/defaults/transitional.js
// module id = 51
// module chunks = 0